export const SendMessageForResize = (sender: string, elementId: string, extraPx = 0) => {
  const element = document.getElementById(elementId);
  const margin = 4;
  const fallBackHeight = 400;
  const elementHeight = element?.scrollHeight ?? fallBackHeight;
  const height = elementHeight + margin + extraPx;

  const messageToIframe = { sender: sender, height };
  if (elementId === "sparerobot") {
    window.parent.postMessage(messageToIframe, "*");
  } else {
    window.parent.postMessage(JSON.stringify(messageToIframe), "*");
  }
};
